var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.5 18",
    style: {
      enableBackground: "new 0 0 21.5 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,16.1V18h-15v-1.9c0-1.7,2.4-3.2,5.5-3.6c0.1-0.3,0.2-0.6,0.2-0.9c0-0.3-0.1-0.6-0.2-0.8C5,10.1,4.2,8.7,4.2,7.2 C4.2,4.9,5.9,3,8,3s3.8,1.9,3.8,4.2c0,1.5-0.7,2.9-1.8,3.6c-0.1,0.3-0.2,0.5-0.2,0.8c0,0.3,0.1,0.6,0.2,0.9 C13.1,12.9,15.5,14.4,15.5,16.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,9c0,0.6-0.4,1-1,1h-6c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1V3c0-1.7,1.3-3,3-3s3,1.3,3,3v1c0.6,0,1,0.4,1,1V9z M17.5,6 c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1s1-0.4,1-1C18.5,6.4,18.1,6,17.5,6z M17.5,1c-1.1,0-2,0.9-2,2v1h4V3C19.5,1.9,18.6,1,17.5,1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.49a70423253e34fe43eb599e44772f05.svg";
export { ForwardRef as ReactComponent };